<ol class="breadcrumb" *ngIf="pathArr">
  <li class="breadcrumb-item" *ngFor="let path of pathArr; let last = last" [ngClass]="(last)?'active':''">
    <a *ngIf="!last" [href]="path.link">{{ path.pathName }}</a>
    <span *ngIf="last && !lastPath">{{ path.pathName }}</span>
    <span *ngIf="last && lastPath">{{ lastPath }}</span>
  </li>
</ol>
